(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/handlers/draw-handlers.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/handlers/draw-handlers.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const {
  http
} = svs.isServer ? require('../proxy-handler.es6') : svs.components.lbUtils.apiProxy;
const featureToggle = svs.isServer ? require('../feature-toggle.es6') : svs.components.lbUtils.apiProxy.featureToggle;
const {
  FEATURE_TOGGLE
} = svs.isServer ? require('../constants.es6') : svs.components.lbUtils.apiProxy.constants;
const getLogger = svs.isServer ? trinidad.logger : svs.core.log.getLogger;
const logger = getLogger('lb-utils:api-proxy:draw-handlers');
const config = {
  shouldUseCloud: async options => {
    const isEnabled = await featureToggle(FEATURE_TOGGLE.BOMBEN_DRAWS_CLOUD_API, options);
    return isEnabled;
  },
  allowedProducts: ['bomben'] 
};

const drawResolver = async _ref => {
  let {
    data,
    params
  } = _ref;
  if (!data.draw) {
    logger.warn('Draw data is missing in the response from cloud API:', data, params);
    return {
      draw: null
    };
  }
  return data;
};

const drawsResolver = async _ref2 => {
  let {
    data,
    params
  } = _ref2;
  if (!data.draws) {
    logger.warn('Draw data is missing in the response from cloud API:', data, params);
    return {
      draws: null
    };
  }
  if (!Array.isArray(data.draws)) {
    logger.warn('Draw data is not an array in the response from cloud API:', data, params);
    return {
      draws: null
    };
  }
  return data;
};
const drawHandlers = [http.get('/draw/1/:product/draws/:drawNumber?include=:include', drawResolver, {
  config: _objectSpread(_objectSpread({}, config), {}, {
    cloudEndpointTemplate: '/v1/:product/draws/:drawNumber'
  })
}), http.get('/draw/1/:product/draws?include=:include', drawsResolver, {
  config: _objectSpread(_objectSpread({}, config), {}, {
    cloudEndpointTemplate: '/v1/:product/draws'
  })
})];
if (svs.isServer) {
  module.exports = drawHandlers;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.handlers.drawHandlers', drawHandlers);
}

 })(window);